import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'


const useStyles = makeStyles(styles);

export default function Jobs(props) {
  const { user } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    jobs: user && user.jobs,
    title: user&&user.title
  });
  var Call = () => {
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      jobs:state.jobs,
      title:state.title,
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        swal("با موفقیت انجام شد.");
      }).catch((err) => {
        if (err&&err.response&&err.response.status&&err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
          else if(err&&err.response&& err.response.data&&err.response.data.fa_message){
          swal(err.response.data.fa_message);
          }
        else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const removeFromList = (source, tttt, valueToRemove) => {
    var e = source.filter(item => item !== valueToRemove)
    setState({ ...state, [tttt]: e })
  };

  const addToJobList = () => {
    if (state.position == "" || state.company == "")
      return swal("هیچ یک از مقادیر نمی تواند خالی باشد.");
    state.jobs.push(state.company+" ("+state.position+")")
    setState({ ...state, "jobs": state.jobs })
    setState({ ...state, "position": "", "company": "" })
  };
  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined" >

            <GridContainer>
              <GridItem xs={12} sm={12} md={5}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    سوابق شغلی
      </Typography>
                  <div className={classes.formInput}>
                    <TextField className={classes.limitWidthMedium} id="standard-basic" name="position" value={state.position} onChange={handleTextBoxChange} label="سمت" helperText="مثال: مدیر فنی" />
                  </div>
                  <div className={classes.formInput}>
                    <TextField className={classes.limitWidthMedium} id="standard-basic" name="company" value={state.company} onChange={handleTextBoxChange} label="شرکت" helperText="مثال: مرکز تحقیقات شریف" />
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <Button variant="outlined" color="secondary" disableElevation onClick={addToJobList}>
                      افزودن به لیست
</Button>
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <TextField id="standard-basic" defaultValue={user && state.title}  name="title" onChange={handleTextBoxChange} label="خلاصه شغلی" helperText="مثال: توسعه دهنده بک اند یا مدیر پروژه" />
                  </div>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={7}>
                <div className={classes.div}>
                {user && state.jobs.length > 0 ? (
                  <div className={classes.formInput+" "+classes.chipMargin}>
                        {user && state.jobs.map((job) => {
                          return (
                            <Chip variant='outlined' label={job} onDelete={() => { removeFromList(state.jobs, 'jobs', job) }} color="primary"  />
                          );
                        })}
                  </div>
                ) : <p><br/>موردی جهت نمایش وجود ندارد.</p>}
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en +" " +classes.save}>
                <Button variant="contained" color="primary" disableElevation onClick={Call}>
                     ذخیره سازی
</Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>
       
</GridContainer>
    </form>
  );
}